import { defineStore } from 'pinia'

export type SnackbarType = 'success' | 'error'

interface SnackbarState {
  message: string
  show: boolean
  type: SnackbarType
}

export const useSnackbarStore = defineStore('snackbar', {
  state: (): SnackbarState => ({
    message: '',
    show: false,
    type: 'success'
  }),

  actions: {
    showMessage(message: string, type: SnackbarType = 'success') {
      this.message = message
      this.type = type
      this.show = true

      setTimeout(() => {
        this.show = false
      }, type === 'error' ? 5000 : 3000)
    }
  }
})
